import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  getVendor as getVendorApi,
  createVendor as createVendorApi,
  createManager as createManagerApi,
  getTransactionHistory as getTransactionHistoryApi,
  getViewDeposit as getViewDepositApi,
  getViewPurchase as getViewPurchaseApi,
  createCollection as createCollectionApi,
  getFullUsers as getFullUsersApi,
  createDeposit as createDepositApi,
  getDepositPurchase as getDepositPurchaseApi,
  createPurchase as createPurchaseApi,
  getSale as getSaleApi,
  createSales as createSalesApi,
  createShipment as createShipmentApi,
  createCustomers as createCustomersApi,
  customerClosing as customerClosingApi,
  patchDeliveryEntry as patchDeliveryEntryApi,
  getProfit as getProfitApi,
  getGroup as getGroupApi,
  createGroup as createGroupApi,
  getGlobals as getGlobalsApi,
  editGlobals as editGlobalsApi,
  viewDashbord as viewDashbordApi

} from "../../helpers/backend_helper";


export const createManager = createAsyncThunk("settings/createManager", async (event: any) => {
  try {
    const response = createManagerApi(event);
    const data = await response;
    toast.success("manager Added Successfully", { autoClose: 2000 });
    return data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Manager Added Failed";
    toast.error(errorMessage)
    return err;
  }
});

export const createVendor = createAsyncThunk("settings/createVendor", async (event: any) => {
  try {
    const response = createVendorApi(event);
    const data = await response;
    toast.success("Vendor Added Successfully", { autoClose: 2000 });
    return data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Manager Added Failed";
    toast.error(errorMessage)
    return err;
  }
});

export const getVendor = createAsyncThunk("dashbord/userData", async () => {
  try {
    const response = await getVendorApi();
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getTransactionHistory = createAsyncThunk("dashbord/getTransactionHistory", async () => {
  try {
    const response = await getTransactionHistoryApi();
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getViewDeposit = createAsyncThunk("dashbord/getViewDeposit", async () => {
  try {
    const response = await getViewDepositApi();
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getViewPurchase = createAsyncThunk("dashbord/getViewPurchase", async () => {
  try {
    const response = await getViewPurchaseApi();
    return response.data;
  } catch (error) {
    return error;
  }
});


export const createCollection = createAsyncThunk("settings/createCollection", async (event: any) => {
  try {
    const response = createCollectionApi(event);
    const data = await response;
    toast.success("Added to  Collection Successfully", { autoClose: 2000 });
    return data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Collection Added Failed";
    toast.error(errorMessage)
    return err;
  }
});


export const getFullUsers = createAsyncThunk("dashbord/getFullUsers", async () => {
  try {
    const response = await getFullUsersApi();
    return response.data;
  } catch (error) {
    return error;
  }
});





export const getSale = createAsyncThunk("dashbord/getSale", async () => {
  try {
    const response = await getSaleApi();
    return response.data;
  } catch (error) {
    return error;
  }
});
export const getDepositPurchase = createAsyncThunk("dashbord/getDepositPurchase", async () => {
  try {
    const response = await getDepositPurchaseApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const createDeposit = createAsyncThunk("settings/createDeposit", async (event: any) => {
  try {
    const response = createDepositApi(event);
    const data = await response;
    toast.success("Deposit Added Successfully", { autoClose: 2000 });
    return data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Deposit Added Failed";
    toast.error(errorMessage)
    return err;
  }
});



export const createPurchase = createAsyncThunk("settings/createPurchase", async (event: any) => {
  try {
    const response = createPurchaseApi(event);
    const data = await response;
    toast.success("Purchase Added Successfully", { autoClose: 2000 });
    return data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Purchase Added Failed";
    toast.error("Vendor has Not enough Balance", { autoClose: 2000 })
    return err;
  }
});

export const createSales = createAsyncThunk("settings/createSales", async (event: any) => {
  try {
    const response = createSalesApi(event);
    const data = await response;
    toast.success("Sales Added Successfully", { autoClose: 2000 });
    return data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Sales Added Failed";
    toast.error(errorMessage)
    return err;
  }
});

export const createShipment = createAsyncThunk("settings/createShipment", async (event: any) => {
  try {
    const response = await createShipmentApi(event);
    toast.success("Shipment Added Successfully", { autoClose: 2000 });
    return response.data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Shipment Added Failed";
    toast.error(errorMessage)
    return err;
  }
})

export const createCustomers = createAsyncThunk("settings/createCustomers", async (event: any) => {
  try {
    const response = await createCustomersApi(event);
    toast.success("Customers Added Successfully", { autoClose: 2000 });
    return response.data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Customers Added Failed";
    toast.error(errorMessage)
    return err;
  }
})

export const customerClosing = createAsyncThunk("settings/customerClosing", async (event: any) => {
  try {
    const response = await customerClosingApi(event);
    toast.success("Sales Completed Successfully", { autoClose: 2000 });
    return response.data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Sales Added Failed";
    toast.error(errorMessage)
    return err;
  }
})

export const patchDeliveryEntry = createAsyncThunk("settings/patchDeliveryEntry", async (data: any) => {
  try {
    const response = await patchDeliveryEntryApi(data);
    toast.success("Shipment Closed Successfully", { autoClose: 2000 });
    return response.data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Shipment Closed Failed";
    toast.error(errorMessage)
    return err;
  }
})

export const getProfit = createAsyncThunk("dashbord/getProfit", async () => {
  try {
    const response = await getProfitApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const getGroup = createAsyncThunk("dashbord/getGroup", async () => {
  try {
    const response = await getGroupApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const createGroup = createAsyncThunk("settings/createGroup", async (event: any) => {
  try {
    const response = await createGroupApi(event);
    toast.success("Group Added Successfully", { autoClose: 2000 });
    return response.data;
  } catch (err: any) {
    const errorMessage = err?.error || err?.message || "Group Added Failed";
    toast.error(errorMessage)
    return err;
  }
})

export const getGlobals = createAsyncThunk("dashbord/getGlobals", async () => {
  try {
    const response = await getGlobalsApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const editGlobals = createAsyncThunk("dashboard/editGlobals", async (payload: { fixrate: number; transferFixrate: number }, thunkAPI) => {
  try {
    const response = await editGlobalsApi(payload);
    toast.success("Global values updated successfully", { autoClose: 2000 });
    return response.data;
  } catch (error: any) {
    toast.error("Failed to update global values", { autoClose: 2000 });
    return thunkAPI.rejectWithValue(error.response?.data || "Update Failed");
  }
});   

export const viewDashbord = createAsyncThunk("dashbord/viewDashbord", async () => {
  try {
    const response = await viewDashbordApi();
    return response;
  } catch (error) {
    return error;
  }
});